import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <div className="p-9">
              <hr className="border-t border-gray-400 mx-6 my-4" />

            <ul className="flex items-center justify-center gap-3 text-[12px] text-slate-500 bold ">
                <li>
                    <Link>
                        Aide
                    </Link>
                </li>
                <li>
                    <Link>
                      Contact
                    </Link>
                </li>
                <li>
                    <Link>
                        Sécurité
                    </Link>
                </li>
                <li>
                    <Link>
                       Respect de la vie privée
                    </Link>
                </li>
                  <li>
                    <Link>
                      Contrat d'utilisations
                    </Link>
                </li>
                  <li>
                    <Link>
                      Mentions légales
                    </Link>
                </li>
            </ul>
            <h1 className="text-center text-[12px] text-slate-500 mt-7">© 2025 FormaFusion. Tous droits réservés.</h1>

        </div>
    )
}